import type {ReactAction} from '@netx/core/bootstrap';
import {faArchive} from '@fortawesome/pro-solid-svg-icons';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {cartActionManageArchiveArchive} from './cart-manage-archive-archive';
import {cartActionManageArchiveUnarchive} from './cart-manage-archive-unarchive';

/**
 * Manage cart archive
 * @param params
 * @returns Action
 */
export const cartActionManageArchive = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'current-cart-manage-archive',
	get label() {
		return CART_CURRENT_ACTION_LABELS.MANAGE_ARCHIVE;
	},
	icon: faArchive,
	cb: () => {},
	children: [
		cartActionManageArchiveArchive(),
		cartActionManageArchiveUnarchive(),
	],
	...params,
});

export default cartActionManageArchive;
